var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-wrapper",
    class: {
      hideSidebar: !_vm.sidebar.opened
    }
  }, [(_vm.showLayout) ? _c('div', {
    staticClass: "sidebar-wrapper",
    on: {
      "mouseover": function($event) {
        _vm.toggleSidebar()
      }
    }
  }, [_c('sidebar', {
    staticClass: "sidebar-container"
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "main-container"
  }, [(_vm.showLayout) ? _c('navbar') : _vm._e(), _vm._v(" "), _c('app-main')], 1)])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-29d0b9f6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29d0b9f6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/Layout.vue
// module id = izhu
// module chunks = 182